/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import CreateSignature from "../CreateSignature/CreateSignature";
import {
  AuthToken,
  SignatureData,
} from "../../interfaces/Signature";
import TokenService from "../../services/TokenStorage";
import { SignatureService } from "../../services/Esignature";
import { InsightService } from "@pepper/insights-react";
import { authenticateToken } from "../../helpers/security-helper";
import CustomLoading from "../../components/CustomLoading/CustomLoading";

const GeneralSignature = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [accessToken, setAccessToken] = useState<AuthToken>();
  const [signatureData, setSignatureData] = useState<SignatureData>();
  //TODO EMPIEZA AQUI
  // Ingresar url Token params
  const queryString = window?.location?.search;

  const urlParams = new URLSearchParams(queryString);

  const token = urlParams.get("token");
  const viewMode = urlParams.get("view_mode");

  useEffect(() => {
    setLoading(true);
    fetchData();
  }, []);

  const fetchData = async () => {
    /* Si hemos recibido el token se lanza la llamada y en el basic authorization 
    va el client_Secret en base64 */
    let accessToken = TokenService.getToken();
    if (accessToken) TokenService.clearToken();
    if (token) {
      let tokenS = token?.replace(/\s/g, "+");
      await authenticationRequest(tokenS);
      accessToken = TokenService.getToken();
      if (accessToken) {
        // Se llama al servicio de firma para obtener los datos de la firma
        const signatureResponse = await SignatureService.getSignature();
        setAccessToken({ access_token: accessToken });
        setSignatureData(signatureResponse);
        setLoading(false);
        InsightService.logTrace("Firma cargada correctamente", [
          { Signature: signatureResponse },
        ]);
      }
    }
  };

  const authenticationRequest = async (token: string) => {
    const response = await authenticateToken(token);
    return !!response;
  };

  return (
    <div>
      {loading && <CustomLoading />}
      {signatureData && accessToken && (
        <CreateSignature
          putProps={{
            signatureData,
            aToken: accessToken,
            mode: viewMode || "null",
          }}
        />
      )}
    </div>
  );
};

export default GeneralSignature;
